<div class="stepper">
  <div class="stepper_body">
    <div *ngFor="let step of stepForms; let i = index" class="step">
      <div *ngIf="currentStep === i" class="stepper_body_form">
        <form
          class="stepper-form"
          [formGroup]="step.form"
          (submit)="onSubmitStep()"
          novalidate
        >
          <div class="form-group">
            <div
              *ngFor="let field of step.fields; let j = index"
              class="input-group input-group-alternative mb-3"
              [class.has-error]="hasError(i, field.name)"
            >
              <!-- Full Name Input -->
              <input
                *ngIf="field.name === 'firstName'"
                [formControlName]="field.name"
                class="form-control"
                [placeholder]="field.text"
                [type]="field.type"
                [class.is-invalid]="hasError(i, field.name)"
              />

              <!-- Avatar Image Upload -->
              <div
                *ngIf="
                  field.type === 'file' &&
                  field.name !== 'commertialRegister' &&
                  field.name !== 'identityCard' &&
                  field.name !== 'drivingLicense'
                "
                class="stepper-form-img"
              >
                <div class="stepper-form-img_img">
                  <input
                    type="file"
                    accept="image/*"
                    #fileInput
                    (change)="onFileInput($event.target)"
                  />
                  <a (click)="fileInput.click()">
                    <img
                      [ngClass]="{ 'br-50': avatar }"
                      [src]="imgPath"
                      alt="cam"
                    />
                  </a>
                </div>
                <span class="stepper-form-img_text">إضافة صورة</span>
                <div
                  *ngIf="field.required && !avatar && formSubmitted"
                  class="mt-1 text-danger small"
                >
                  صورة الملف الشخصي مطلوبة
                </div>
              </div>

              <!-- Commercial Register -->
              <div
                *ngIf="
                  (field.type === 'file' &&
                    field.name === 'commertialRegister' &&
                    !field?.for) ||
                  (field.type === 'file' &&
                    field.name === 'commertialRegister' &&
                    field?.for &&
                    field?.for === transporterType)
                "
                class="stepper-form-img-commercial"
              >
                <div class="">
                  <input
                    type="file"
                    accept="image/*,.pdf"
                    #fileInputCommercial
                    (change)="onFileCommercialRegisterChange($event.target)"
                  />
                  <a
                    class="image-commercial-container"
                    (click)="fileInputCommercial.click()"
                  >
                    <img
                      class="image-commercial"
                      [src]="imgCommercialPath"
                      alt="cam"
                    />
                  </a>
                  <span class="stepper-form-img_text">{{ field.text }}</span>
                  <div
                    *ngIf="
                      field.required && !commercialRegister && formSubmitted
                    "
                    class="mt-1 text-danger small"
                  >
                    {{ field.text }} مطلوب
                  </div>
                </div>
              </div>

              <!-- Identity Card -->
              <div
                *ngIf="
                  field.type === 'file' &&
                  field.name === 'identityCard' &&
                  field?.for &&
                  field?.for == transporterType
                "
                class="mt-3 stepper-form-img-commercial"
              >
                <div class="">
                  <input
                    type="file"
                    #fileInputIdentityCard
                    accept="image/*,.pdf"
                    (change)="onFileIdentityCardChange($event.target)"
                  />
                  <a
                    class="image-commercial-container"
                    (click)="fileInputIdentityCard.click()"
                  >
                    <img
                      class="image-commercial"
                      [src]="imgIdentityCardPath"
                      alt="cam"
                    />
                  </a>
                  <span class="stepper-form-img_text">{{ field.text }}</span>
                  <div
                    *ngIf="field.required && !identityCard && formSubmitted"
                    class="mt-1 text-danger small"
                  >
                    {{ field.text }} مطلوب
                  </div>
                </div>
              </div>

              <!-- Driving License -->
              <div
                *ngIf="
                  field.type === 'file' &&
                  field.name === 'drivingLicense' &&
                  field?.for &&
                  field?.for == transporterType
                "
                class="stepper-form-img-commercial"
              >
                <div class="">
                  <input
                    type="file"
                    #fileInputdrivingLicense
                    accept="image/*,.pdf"
                    (change)="onFiledrivingLicense($event.target)"
                  />
                  <a
                    class="image-commercial-container"
                    (click)="fileInputdrivingLicense.click()"
                  >
                    <img
                      class="image-commercial"
                      [src]="imgdrivingLicensePath"
                      alt="cam"
                    />
                  </a>
                  <span class="stepper-form-img_text">{{ field.text }}</span>
                  <div
                    *ngIf="field.required && !drivingLicense && formSubmitted"
                    class="mt-1 text-danger small"
                  >
                    {{ field.text }} مطلوب
                  </div>
                </div>
              </div>

              <!-- Date Input -->
              <input
                *ngIf="field.type === 'date'"
                [formControlName]="field.name"
                class="form-control"
                [placeholder]="field.text"
                [type]="field.type"
                [min]="todayDate"
                [class.is-invalid]="hasError(i, field.name)"
              />

              <label
                *ngIf="field.type === 'date' && field.name == 'experyDateOfcr'"
                class="stepper-from_phone-code"
                >{{ field?.text }}</label
              >

              <!-- Regular Text Inputs -->
              <input
                *ngIf="
                  field.type !== 'file' &&
                  field.type !== 'tel' &&
                  field.type !== 'email' &&
                  field.type !== 'select' &&
                  field.type !== 'date' &&
                  field.name != 'otp' &&
                  field.name !== 'firstName'
                "
                [formControlName]="field.name"
                class="form-control"
                [placeholder]="field.text"
                [type]="field.type"
                [class.is-invalid]="hasError(i, field.name)"
              />

              <!-- Phone Number Input -->
              <div
                class="d-flex align-items-center w-100"
                *ngIf="field.type === 'tel'"
              >
                <label class="mr-2 stepper-from_phone-code">
                  <span>
                    {{ phoneCode }}
                  </span>
                </label>
                <div class="flex-grow-1">
                  <input
                    [formControlName]="field.name"
                    [(ngModel)]="phoneNumber"
                    class="form-control"
                    pattern="\d*"
                    [maxlength]="phoneLength"
                    [placeholder]="field.text"
                    [type]="field.type"
                    [class.is-invalid]="hasError(i, field.name)"
                  />
                </div>
              </div>

              <label
                *ngIf="field.name === 'experyDateOfdl'"
                class="stepper-from_phone-code"
              >
                إنتهاء الصلاحية
              </label>

              <!-- Email Input -->
              <input
                *ngIf="field.type === 'email'"
                [formControlName]="field.name"
                [(ngModel)]="email"
                class="form-control"
                [placeholder]="field.text"
                [type]="field.type"
                [class.is-invalid]="hasError(i, field.name)"
              />

              <!-- Select Inputs (except region) -->
              <select
                dir="rtl"
                class="form-control"
                *ngIf="field?.type === 'select' && field?.name != 'region'"
                [formControlName]="field.name"
                [attr.disabled]="field?.disabled"
                [class.is-invalid]="hasError(i, field.name)"
              >
                <option value="" selected disabled>{{ field?.text }}</option>
                <option
                  *ngFor="let child of field?.childs"
                  [value]="child?.value"
                >
                  {{ child?.key }}
                </option>
              </select>

              <!-- Region Select Input -->
              <select
                dir="rtl"
                class="form-control"
                *ngIf="field?.type == 'select' && field?.name == 'region'"
                [formControlName]="field.name"
                [class.is-invalid]="hasError(i, field.name)"
              >
                <option value="" selected disabled>{{ field?.text }}</option>
                <option *ngFor="let region of regions" [value]="region?.id">
                  {{ region?.key }}
                </option>
              </select>

              <!-- SINGLE VALIDATION MESSAGE PER FIELD (FIXED DUPLICATE ISSUE) -->
              <div
                *ngIf="hasError(i, field.name)"
                class="d-block invalid-feedback"
              >
                {{ getValidationMessage(i, field.name) }}
              </div>
            </div>

            <!-- OTP Section -->
            <div
              *ngIf="isOtpSent && currentStep + 1 === stepperConfig.number"
              class="mb-4 otp-section"
            >
              <label class="form-label">رمز التحقق</label>
              <div class="d-flex align-items-center">
                <input
                  type="text"
                  class="form-control"
                  placeholder="أدخل رمز التحقق"
                  [formControl]="otp"
                  [class.is-invalid]="
                    otp.invalid && (otp.touched || formSubmitted)
                  "
                  maxlength="6"
                />
                <button
                  type="button"
                  class="mr-2 btn-outline-primary btn"
                  (click)="sendOtpVerification()"
                  [disabled]="!phoneNumber || !email"
                >
                  إعادة الإرسال
                </button>
              </div>
              <div
                *ngIf="otp.invalid && (otp.touched || formSubmitted)"
                class="d-block invalid-feedback"
              >
                {{ getValidationMessage(i, 'otp') }}
              </div>
            </div>

            <!-- Checkboxes Section (only on final step) -->
            <div
              *ngIf="
                currentStep + 1 === stepperConfig.number &&
                i + 1 === stepForms.length
              "
              class="my-2 text-right row"
            >
              <div class="row">
                <hr />
                <a class="mx-3" (click)="openRulesModal()">
                  الإطلاع على الشروط والأحكام
                </a>
                <hr />
              </div>

              <!-- Terms and Conditions Checkbox -->
              <div class="d-flex justify-content-end mb-2 col-12">
                <label class="mx-3 custom-toggle">
                  <input
                    type="checkbox"
                    [checked]="isLegacyAccepted"
                    (change)="onChangeCheck('legacy')"
                  />
                  <span class="rounded-circle custom-toggle-slider"></span>
                </label>
                <label>
                  <span
                    >أوافق على
                    <a (click)="openRulesModal()">الشروط والأحكام</a></span
                  >
                </label>
              </div>
              <div
                *ngIf="!isLegacyAccepted && formSubmitted"
                class="text-danger text-right col-12"
              >
                يجب الموافقة على الشروط والأحكام للمتابعة
              </div>

              <!-- Transactional Messages Checkbox -->
              <div class="d-flex justify-content-end mb-2 col-12">
                <label class="mx-3 custom-toggle">
                  <input
                    type="checkbox"
                    [checked]="receiveTransactionalMessages"
                    (change)="onChangeCheck('transactional')"
                  />
                  <span class="rounded-circle custom-toggle-slider"></span>
                </label>
                <label>
                  <span
                    >أوافق على استلام الرسائل المعاملاتية / الترويجية على
                    الواتساب</span
                  >
                </label>
              </div>
            </div>
          </div>

          <!-- Navigation Buttons -->
          <div class="stepper-btns">
            <div class="text-center">
              <button
                type="submit"
                class="btn btn-primary btn-register"
                [disabled]="isOtpSent && otp.invalid"
              >
                <span *ngIf="currentStep + 1 !== stepperConfig.number">
                  التالي
                </span>
                <span *ngIf="currentStep + 1 === stepperConfig.number">
                  إنشاء حساب
                </span>
              </button>
            </div>
            <div class="text-center">
              <button
                type="button"
                (click)="backStep()"
                class="btn-outline-secondary btn"
              >
                <span *ngIf="currentStep < 1"> إلغاء </span>
                <span *ngIf="currentStep >= 1"> رجوع </span>
              </button>
            </div>
          </div>

          <!-- Login Link -->
          <div class="py-2 text-center">
            <a
              [routerLink]="[APP_ROUTES.AUTH.LOGIN]"
              [queryParams]="{ type: type }"
              class="text-black c-pointer"
              ><small>تسجيل الدخول ؟</small></a
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- MODAL RULES -->
<div
  class="modal fade bd-example-modal-lg"
  id="modal_rules"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <h5 class="text-right modal-title" id="exampleModalLabele">
          الشروط والأحكام
        </h5>
      </div>
      <div class="modal-body">
        <app-rules-register
          [isSignup]="true"
          [type]="type"
        ></app-rules-register>
      </div>
      <div class="modal-footer d-none">
        <button
          type="button"
          #btnCloseModalHistoric
          class="btn btn-secondary"
          data-dismiss="modal"
        >
          إغلاق
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Hidden button to trigger modal -->
<button
  class="v-none"
  #btn_modal_rules
  data-toggle="modal"
  data-target="#modal_rules"
></button>
